define([
    "./pathModule",
    "./pathService"
], function(){

});